import React, {Component } from 'react';
import firebase from 'firebase/app'

export default class PictographsElectricityController extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      billData: null,
    }
  }

  componentDidMount() {
    let result = null;

    
    let year = new Date().getFullYear();
    let month = new Date().getMonth();
    
    var formattedNumber = ("0" + month).slice(-2) + '-' + year;


    
    
    let userKey = this.props.user.email.replace(/[^a-zA-Z0-9]/g, "");
    let billsRef = firebase.database().ref('userBills/' + userKey + '/electric');
    billsRef.on('value', getData)

  

    function getData(data) {
      if (data.exists() && data.val()[formattedNumber] != null) {
        let tvHours = Math.round(data.val()[formattedNumber].amount / .234)
        const item = (<span>{tvHours} hours of watching TV in electricity</span>); 
        console.log(item);
        result = item
        console.log(result);
      } else {
        const item = (<span>You have no available electricity bills for this month</span>);
        result = item
      }
    }

    this.setState({billData: result})
   
  }


  render() {
    return (
      <div className='pictograph-container column'>
        <div className>
        <img className='pictograph-image' alt="cartoon TV with remote" src='/img/tv.png'></img>
          {this.state.billData}</div>
      </div>
    )
  }
}